// @flow

import { ENTITY_NAME as ROUTE_STAGE_RESULT } from './entity';
import { getEntities } from '../selector';

export const getRouteStageResults = getEntities(ROUTE_STAGE_RESULT);
